import { Zap } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerRulesSpec: ModuleSpec = {
  id: "customer-rules",
  icon: Zap,
  i18n: {
    namespace: "modules",
    titleKey: "customer-rules.title",
    descriptionKey: "customer-rules.description",
  },
  nav: {
    path: "/customers/rules",
    group: "observe",
    order: 60,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Configure automation rules and triggers",
  },
};
